import { notification } from 'antd';
import CryptoJS from 'crypto-js';

export const MessageType = {
  Success: 'success',
  Warning: 'warning',
  Error: 'error',
  CatchError: 'catcherror',
};

export const showNotification = (Type, message) => {
  if (Type === 'catcherror') {
    if (message === '') {
      message = 'Something went to Wrong,Please Try again!.';
    }
    Type = MessageType.Error;
  }
  notification[Type]({
    message: Type,
    description: message,
  });
};

export const decryptToken = (cipherText, key = 'Barksdale@1922##') => {
  if (/^[0-9a-fA-F\-]{36}$/.test(cipherText)) {
    // It's a UUID, not an encrypted token
    console.warn('Token is not encrypted, returning as-is');
    return cipherText;
  }

  try {
    const iv = CryptoJS.enc.Utf8.parse('1234567890123456');
    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);

    const decrypted = CryptoJS.AES.decrypt(cipherText, keyUtf8, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });


    const utf8Output = decrypted.toString(CryptoJS.enc.Utf8);


    if (!utf8Output) throw new Error('Decryption failed. Empty result.');

    return utf8Output;
  } catch (err) {
    console.log('Decryption Error:', err);
    return null;
  }
};
